export const messages = {
    loginCardButtonCta: 'Log in now',
    loginCardTitle: 'Have an ACKO policy? Get an even better deal!',
};
